export default __webpack_public_path__ + "static/media/50-percent-finished.f018242e.mp3";